import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import { FeedbackAlert } from '../FeedbackAlert/FeedbackAlert'
import { Header } from '../Header/Header'
import { Sidebar } from '../Sidebar/Sidebar'
import { LayoutEmpty } from './LayoutEmpty'
import LayoutMobileProtected from './LayoutMobileProtected'

interface Props {
  className?: string
}

export const LayoutDashboard: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
}) => {
  return (
    <>
      <div className="hidden lg:block">
        <LayoutEmpty>
          <Header withUser />
          <div className="flex flex-row">
            <Sidebar />
            <div
              className={clsx(
                'relative flex min-h-dashboardViewport min-w-0 flex-1',
                className
              )}
            >
              {children}
              <FeedbackAlert />
            </div>
          </div>
        </LayoutEmpty>
      </div>
      <div className="block lg:hidden">
        <LayoutMobileProtected />
      </div>
    </>
  )
}
